import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-leer-mas',
  templateUrl: './leer-mas.component.html',
  styleUrls: ['./leer-mas.component.css']
})
export class LeerMasComponent {

  @Input() texto: string = '';
  @Input() limite: number = 150;

  mostrarTextoCompleto = false;

  constructor(private sanitizer: DomSanitizer) {}

  get necesitaLeerMas(): boolean {
    // Si 'texto' no existe, su length no será mayor que el límite
    return (this.texto?.length ?? 0) > this.limite;
  }

  get textoMostrado(): SafeHtml {
    // Aseguramos que 'texto' sea al menos un string vacío si llega undefined o null
    const textoSeguro = this.texto ?? '';

    const textoFinal =
      this.mostrarTextoCompleto
        ? textoSeguro
        : textoSeguro.substring(0, this.limite) + (this.necesitaLeerMas ? '...' : '');

    return this.sanitizer.bypassSecurityTrustHtml(textoFinal);
  }

  toggle() {
    this.mostrarTextoCompleto = !this.mostrarTextoCompleto;
  }
}